export const GET_ENABLE_ONLINE_AUCTION = 'innovA/featureFlags#getEnableOnlineAuction';
export const LOADING_FEATURE_FLAGS = 'innovA/featureFlags#loadingFeatureFlags';
